import { ThemeConfig, theme as defaultThemeConfig } from '../core/App/theme';
import { useTheme as useMuiTheme } from '@mui/material';

function useTheme(): ThemeConfig {
  const muiTheme = useMuiTheme();
  // MUI's useTheme returns an empty object ({}) when outside a ThemeProvider.
  // Fall back to the static theme config in that case.
  if (muiTheme && 'palette' in muiTheme) {
    return muiTheme as unknown as ThemeConfig;
  }
  return defaultThemeConfig as ThemeConfig;
}

export default useTheme;
